export default [
    {
        provides: 'accessibility',
    },
    {
        provides: 'chat',
    },
    {
        provides: 'newsletter',
    },
    {
        provides: 'log',
        error(err, metaData) {
            console.error(err, metaData)
        },
        warning(err, metaData) {
            console.warn(err, metaData)
        },
        info(err, metaData) {
            console.log(err, metaData)
        },
    },
]
